import React, { useEffect, useState } from 'react';
import {
    buildHashesMatcher,
    isBuildInfoEnabled,
    disableBuildInfo,
    onBuildInfoAvailabilityChange,
} from '~spa/Utils/BuildInfo';

const BuildInfo = () => {
    const [isVisible, setIsVisible] = useState(isBuildInfoEnabled());

    useEffect(() => {
        const visibilityController = (_, isEnabled) => setIsVisible(isEnabled);
        const unsubscribe = onBuildInfoAvailabilityChange(visibilityController);

        return () => {
            unsubscribe();
        };
    }, []);

    if (!isVisible) {
        return null;
    }

    const {
        isMatch,
        mismatches,
        latestHash,
        clientHash,
        ssrHash,
    } = buildHashesMatcher();

    const OK = '#8bc34a';
    const WARNING = '#ff9800';
    const ERROR = '#f44336';

    const styles = {
        div: {
            background: '#000',
            color: '#999',
            padding: '0.5rem',
            fontSize: '0.8rem',
        },
        span: {
            display: 'block',
            marginTop: '0.5rem',
            padding: '0.5rem',
            textAlign: 'center',
            border: '1px solid rgba(255,255,255,0.2)',
        },
        dt: {
            marginTop: '0.2rem',
        },
        dd: {
            fontFamily: 'monospace',
            marginLeft: '1rem',
            color: (isMatch ? OK : '#fff'),
        },
    };

    const hashes = [
        {
            label: 'Latest Build Hash',
            hash: latestHash,
            customStyle: {},
        },
        {
            label: 'Client Build Hash',
            hash: clientHash,
            customStyle: (mismatches.includes('latest|client') && {color: WARNING}),
        },
        {
            label: 'SSR Build Hash (head_scripts)',
            hash: ssrHash,
            customStyle: (
                !isMatch && {
                    color: (
                        mismatches.includes('client|ssr') && ERROR
                        ||
                        mismatches.includes('latest|ssr') && WARNING
                    ),
                }
            ),
        },
    ];

    return (
        <div style={styles.div}>
            <dl>
                {hashes.map(({label, hash, customStyle}) => (
                    <React.Fragment key={label}>
                        <dt style={styles.dt}>
                            {label}
                        </dt>
                        <dd style={{...styles.dd, ...customStyle}}>
                            {hash}
                        </dd>
                    </React.Fragment>
                ))}
            </dl>
            <span style={styles.span} onClick={() => disableBuildInfo()}>Close!</span>
        </div>
    );
};

export default BuildInfo;
